<script>
    export default {
        name: "UserDataMixin",
        props: ['tabData'],
        data() {
            return {
                baseUserData: {}
            }
        },
        created() {
            this.baseUserData = this.tabData;
        },
        watch: {
            tabData: {
                handler() {
                    this.baseUserData = this.tabData;
                },
                deep: true
            }
        }
    }
</script>

<style scoped>

</style>